import JazzySpinner from "@/assets/icons/JazzySpinner";
import { commonComponents as cc } from "@/components/common";
import { ui } from "@/components/ui";
import { diariesByPatientQueryOptions } from "@/features/diaries/api";
import { useDiariesByPatientQuery } from "@/features/diaries/api/diaryQueries";
import DiaryList from "@/features/diaries/components/DiaryList";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { useDiaryInvalidation } from "../../../features/diaries/api/diaryInvalidation";

const DiariesContent = () => {
	const { auth } = Route.useRouteContext();
	const { data: diaries } = useDiariesByPatientQuery(auth.id);
	const { invalidateByPatient } = useDiaryInvalidation();

	const hasNoDiaries = diaries.length === 0;

	return (
		<section className="md-width">
			<cc.Title words="Diaries">
				{hasNoDiaries && (
					<ui.Card className="mt-4">
						<ui.CardHeader>
							<ui.CardTitle>No Diaries Yet</ui.CardTitle>
							<ui.CardDescription>
								Diaries created by your care team appear here
							</ui.CardDescription>
						</ui.CardHeader>
						<ui.CardContent>
							<ui.Button onClick={() => invalidateByPatient(auth.id)}>
								Check Again
							</ui.Button>
						</ui.CardContent>
					</ui.Card>
				)}
			</cc.Title>
			{!hasNoDiaries && <DiaryList diaries={diaries} />}
		</section>
	);
};

const Diaries = () => {
	useNav([{ label: "Diaries", route: { to: "/diaries" } }]);

	return (
		<Suspense
			fallback={
				<div className="flex justify-center py-8 md-width">
					<JazzySpinner />
				</div>
			}
		>
			<DiariesContent />
		</Suspense>
	);
};

export const Route = createFileRoute("/_app/diaries/")({
	beforeLoad: ({ context }) => {
		return {
			auth: context.auth,
		};
	},
	loader: ({ context }) => {
		return context?.queryClient.ensureQueryData(
			diariesByPatientQueryOptions(context.auth.id),
		);
	},
	component: Diaries,
});
